export default "__VITE_ASSET__604d79e9__"